import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateStyle } from '../api';
import { StyleForm } from '../components';
import { StyleFormValues } from '../validations';

export const NewStylePage: FC = () => {
  const navigate = useNavigate();

  const { createStyleMutation, getUploadUrlDataMutation } = useCreateStyle();

  const saveStyle = async (values: StyleFormValues) => {
    try {
      const { styleId } = await getUploadUrlDataMutation.mutateAsync({
        file: values.imagePublicUrl as File,
      });

      if (styleId) {
        await createStyleMutation.mutateAsync({
          id: styleId,
          name: values.name,
          negativePrompts: values.negativePrompts,
          gptPromptTemplate: values.gptPromptTemplate,
          userPromptTemplate: values.userPromptTemplate,
        });
      } else {
        throw new Error('Style ID is missing from upload URL data.');
      }

      navigate(Routes.Styles, { replace: true });
      toast.success(`Style “${values.name}” added successfully!`);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <>
      <StyleForm onSubmit={saveStyle}>
        <PageHeader
          title="New Style"
          asChildPage
          backPath={Routes.Styles}
          actions={[
            <Button
              key="create-style"
              type="submit"
              data-testid="create-style-button"
              isLoading={
                getUploadUrlDataMutation.isPending ||
                createStyleMutation.isPending
              }
              startIcon={<PlusSquareIcon />}
            >
              Create new style
            </Button>,
          ]}
        />
      </StyleForm>
    </>
  );
};
